var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 16.6253C22.156 16.6253 21.75 17.0173 21.75 17.5003V25.3753H1.8125V6.12527H9.96875C10.469 6.12527 10.875 5.73327 10.875 5.25027C10.875 4.76727 10.469 4.37527 9.96875 4.37527H0.90625C0.406 4.37527 0 4.76727 0 5.25027V26.2503C0 26.7333 0.406 27.1253 0.90625 27.1253H22.6562C23.1565 27.1253 23.5625 26.7333 23.5625 26.2503V17.5003C23.5625 17.0173 23.1565 16.6253 22.6562 16.6253Z",
    fill: "#2A0C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.69 7.21729L21.44 1.09229C21.1736 0.864786 20.7929 0.810536 20.4685 0.954036C20.1459 1.09579 19.9374 1.40729 19.9374 1.75029V4.37529H19.4009C13.5756 4.37529 8.56219 8.57353 7.73751 14.142L7.25901 17.3778C7.19919 17.7855 7.44207 18.181 7.84626 18.3228C7.94776 18.3578 8.05288 18.3753 8.15619 18.3753C8.46069 18.3753 8.75613 18.2265 8.92469 17.964L10.2605 15.899C12.0948 13.0675 15.2558 11.3753 18.7158 11.3753H19.9374V14.0003C19.9374 14.3433 20.1459 14.6548 20.4685 14.7965C20.7893 14.9383 21.1718 14.8858 21.44 14.6583L28.69 8.53329C28.8876 8.36704 28.9999 8.12904 28.9999 7.87529C28.9999 7.62154 28.8876 7.38354 28.69 7.21729ZM21.7499 12.0718V10.5003C21.7499 10.0173 21.3439 9.62529 20.8437 9.62529H18.7158C15.1633 9.62529 11.8773 11.1338 9.65513 13.7255C10.6339 9.34879 14.7066 6.12529 19.4009 6.12529H20.8437C21.3439 6.12529 21.7499 5.73329 21.7499 5.25029V3.67879L26.718 7.87529L21.7499 12.0718Z",
    fill: "#2A0C66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.413345b766cfc2839a0ca45ca511b59a.svg";
export { ForwardRef as ReactComponent };